module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_white_x2.b2dfc18b.png";